"use client";

import React from "react";
import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-primary-foreground/10 animate-pulse rounded-md" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3 text-sm text-primary-foreground/70">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-primary-foreground transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/lana_connect_logo_footer.png" alt="Lana connect LLC" className="h-7 w-auto" />
            </Link>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              Experts, one connection. We seamlessly connect homeowners and contractors with trusted financing platforms to bring projects to life.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight">Contact Us</h3>
            <ul className="flex flex-col gap-4 text-sm text-primary-foreground/70">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-primary-foreground/50" />
                <span>123 Main St, Springfield</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-primary-foreground/50" />
                <span>(555) 123-4567</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-primary-foreground/50" />
                <span>info@lanaconnect.com</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight">Connect</h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} className="h-10 w-10 rounded-full bg-primary-foreground/5 flex items-center justify-center text-primary-foreground/70 hover:bg-primary-foreground/10 hover:text-primary-foreground transition-all" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <div className="pt-2">
              <Button variant="outline" className="w-full sm:w-auto bg-transparent border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground" asChild>
                <Link to="#">Member Login</Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-primary-foreground/10" />

        <div className="flex flex-col lg:flex-row justify-between items-center gap-6 text-xs text-primary-foreground/50 text-center lg:text-left">
          <p>
            &copy; {currentYear} Lana connect LLC. All rights reserved.
          </p>
          <p className="max-w-3xl leading-relaxed">
            Disclaimer: Lana connect LLC is not a lender. We are a connection service that facilitates access to multiple financing sources for homeowners and contractors. We do not make loan or credit decisions.
          </p>
        </div>
      </div>
    </section>;
}